import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Services from './pages/Services';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import PrivateRoute from './components/PrivateRoute';

function App() {
  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/admin/login';
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />

        {/* LOGIN ADMIN */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* ADMIN PROTEGIDO */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Admin onLogout={handleLogout} />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
